<template>
  <div id="multicards">
    <v-overlay class="tutorial-overlay" :value="showNextButtonTutorial" :opacity="0.5">
      <div class="tutorial-next-arrow">
        <v-img src="../assets/curved-arrow.svg"></v-img>
      </div>
      <div class="hint-box">
        <div class="body">
          <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
          <div class="text-semibold">Jetzt wird es spannend!</div>
          <div class="text-regular">
            Ich konnte die <b>ersten passende Hilfsmittel für Ihre Situation finden</b>. Sie können sich nun die
            Hilfsmittel-Vorschläge genauer ansehen und sich bei Interesse merken.
          </div>
          <br />
          <div class="text-regular">
            Die Beratung geht allerdings im Anschluss noch weiter. Um mit der Beratung später fortzufahren, finden Sie
            <b>oben rechts</b> den <b>Weiter-Knopf.</b>
          </div>
          <img class="quote-bottom" alt="anni logo" src="../assets/quotes.svg" />
          <div align="center">
            <v-btn color="primary" class="primary-txt-btn" text @click="markNextButtonTutorialAsDone()">
              Diesen Hinweis schließen
            </v-btn>
          </div>
        </div>
      </div>
    </v-overlay>
    <div class="progress-header">
      <div class="header-side" :style="{ visibility: !contentData.backButton.hidden ? 'visible' : 'hidden' }">
        <v-btn @click="submitAnswerFromCard('back')" class="prg-header-btn" rounded icon>
          <v-icon size="36px" class="prg-header-icon">mdi-chevron-left</v-icon>
        </v-btn>
        <div class="btn-text">
          <a @click="submitAnswerFromCard('back')">{{ contentData.backButton.text }}</a>
        </div>
      </div>
      <div class="progress-bar" :style="{ visibility: 'hidden' }">
        <v-progress-linear :value="progress" color="blue-grey" height="25">
          <template v-slot:default="{ value }">
            <strong>{{ Math.ceil(value) }}%</strong>
          </template>
        </v-progress-linear>
      </div>
      <div class="next-button">
        <div :style="{ visibility: !contentData.nextButton.hidden ? 'visible' : 'hidden' }" class="header-side">
          <div class="btn-text">
            <a @click="submitAnswerFromCard('next')">{{ contentData.nextButton.text }}</a>
          </div>
          <v-btn @click="submitAnswerFromCard('next')" class="prg-header-btn" rounded icon>
            <v-icon size="36px" class="prg-header-icon">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <section class="anni-section">
      <div class="left">
        <div class="avatar">
          <img alt="anni logo" width="200px" height="200px" src="../assets/ANNI_Design_Round_Image_Green.png" />
        </div>
      </div>
      <div class="body">
        <img class="quote-top" alt="anni logo" src="../assets/quotes.svg" />
        <div class="text-semibold">
          {{ contentData.question.title }}
        </div>
        <div class="text-regular">
          {{ contentData.question.subtitle }}
        </div>
        <img class="quote-bottom" alt="anni logo" src="../assets/quotes.svg" />
      </div>
    </section>

    <section class="response-placeholder">
      <v-carousel
        :show-arrows="!(executableSystemAction.guiTemplateContent.categories.length <= columns)"
        v-if="componentToggles.categoryCard"
        hide-delimiters
        :continuous="false"
      >
        <template v-for="(item, index) in executableSystemAction.guiTemplateContent.categories">
          <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index">
            <v-row class="flex-nowrap" style="height: 100%">
              <template v-for="(n, i) in columns">
                <template v-if="+index + i < executableSystemAction.guiTemplateContent.categories.length">
                  <v-col :key="i">
                    <product-compaire
                      v-if="+index + i < executableSystemAction.guiTemplateContent.categories.length"
                      @submitAnswer="forwardAnswerToAppForBackendProcessing($event)"
                      @addToBasket="addToBasket($event)"
                      ref="categoryCard"
                      :categoryData="executableSystemAction.guiTemplateContent.categories[+index + i]"
                      :indexOfCard="+index + i"
                      :key="+index + i"
                      height="100%"
                      width="100%"
                      max-height="406px"
                    />
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-carousel-item>
        </template>
      </v-carousel>

      <v-carousel v-else hide-delimiters>
        <v-carousel-item v-for="(card, i) in emptyCards" :key="i" class="carousel-item">
          <path-selection v-for="i in 2" :key="i" height="100%" width="100%" max-height="406px" />
        </v-carousel-item>
      </v-carousel>
    </section>
  </div>
</template>
<script>
import PathSelection from "../components/MultiCards/PathSelection.vue"
import ProductCompaire from "../components/MultiCards/ProductCompaire.vue"

const guiTemplateMapping = {
  TitleAndSubtitleWithCategorySelect: "categoryCard",
}

export default {
  components: {
    ProductCompaire,
    PathSelection,
  },
  data() {
    return {
      progress: 68,
      emptyCards: [{}, {}, {}, {}],
      showNextButtonTutorial: null,
      componentToggles: {
        categoryCard: true,
      },
      contentData: {
        question: {
          title:
            "QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG QUESTION TITLE LONG ",
          subtitle:
            "QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE QUESTION SUBTITLE",
        },
        nextButton: {
          text: "nächste Frage",
          hidden: false,
        },
        backButton: {
          text: "zurück",
          hidden: false,
        },
      },
      fixedNumberOfCards: undefined, // allows to set fixed number of cards displayed in carousel from backend
      executableSystemAction: {},
    }
  },
  methods: {
    forwardAnswerToAppForBackendProcessing(data) {
      this.$emit("forwardAnswerToAppForBackendProcessing", data)
    },

    addToBasket(basketData) {
      this.$emit("addToBasket", basketData)
    },

    // updates the question in the screen and triggers updates + visibility of required response components
    updateQuestionAndResponse(executableSystemAction) {
      console.log("INSIDE MULTI")
      console.log(executableSystemAction)

      this.executableSystemAction = executableSystemAction

      // update title + subtitle
      this.contentData.question.title = executableSystemAction.guiTemplateContent.title.text
      this.contentData.question.subtitle = executableSystemAction.guiTemplateContent.subtitle.text

      // assign title of nextButton if defined, otherwise hide
      if (typeof executableSystemAction.guiTemplateContent.nextButton !== "undefined") {
        this.contentData.nextButton.text = executableSystemAction.guiTemplateContent.nextButton.text
      } else {
        this.contentData.nextButton.hidden = true
      }

      // assign title of backButton if defined, hide if specified
      if (typeof executableSystemAction.guiTemplateContent.backButton !== "undefined") {
        // assign text if specified
        if (typeof executableSystemAction.guiTemplateContent.backButton.text !== "undefined") {
          this.contentData.backButton.text = executableSystemAction.guiTemplateContent.backButton.text
        } else {
          this.contentData.backButton.text = "zurück"
        }
        // hide if specified
        if (typeof executableSystemAction.guiTemplateContent.backButton.hidden !== "undefined") {
          this.contentData.backButton.hidden = executableSystemAction.guiTemplateContent.backButton.hidden
        } else {
          this.contentData.backButton.hidden = false
        }
      } else {
        this.contentData.backButton.hidden = false
      }

      // asign fixed number of cards if present
      this.fixedNumberOfCards = executableSystemAction.guiTemplateContent.config?.fixedNumberOfCards

      // decide based on guiTemplate which component in this screen to update
      this.showResponseComponent(guiTemplateMapping[executableSystemAction.guiTemplate])
    },
    // TOOD => unify identical functions between SingleCards and MultiCards
    // shows the desired component, hides the rest by assigning true/false to data.componentToggles
    showResponseComponent(componentToShow) {
      console.log("TOGGLING COMPONENT VISIBILITY")
      console.log(componentToShow)
      for (let component of Object.keys(this.$data.componentToggles)) {
        this.$data.componentToggles[component] = componentToShow == component
      }
      console.log(this.$data.componentToggles)

      // call the updateContent function even when the component was not mounted/destroyed => for cases when identical components after another are used
      this.$refs[guiTemplateMapping[this.executableSystemAction.guiTemplate]].updateContent(this.executableSystemAction)
    },

    // TOOD => unify identical functions between SingleCards and MultiCards
    // used to handle button events directly from this card (next/previous button), not from child components
    submitAnswerFromCard(input) {
      // if tutorial screen is shown, don't execute action on Weiter Button, but close tutorial instead
      if (this.showNextButtonTutorial === true) {
        this.markNextButtonTutorialAsDone()
      } else {
        let newInput = {}

        // switch statement as prep for upcoming onCard events besides next
        switch (input) {
          case "next":
            newInput = {
              nextButton: {
                clicked: true,
              },
            }
            break
          case "back":
            newInput = {
              backButton: {
                clicked: true,
              },
            }
            break
        }
        this.$emit("forwardAnswerToAppForBackendProcessing", newInput)
      }
    },

    // closes the next button overlay and adds a cookie to not play the tutorial again
    markNextButtonTutorialAsDone() {
      this.showNextButtonTutorial = false
      this.$cookies.set("nextButtonTutorial", true)
    },

    // calls the update content for the right Vue component based on the provided mapping
    // TODO => fix first time mounted
    updateResponseComponentContent() {
      this.$refs[guiTemplateMapping[this.executableSystemAction.guiTemplate]].updateContent(this.executableSystemAction)
    },
  },
  mounted() {
    console.log("mount MULTI")
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })

    // check if next button tutorial was already played using cookies
    if (this.$cookies.get("nextButtonTutorial") === null) {
      this.showNextButtonTutorial = true
    }
  },
  destroyed() {
    //TODO: switch to unmount when upgrade to Vue3
    console.log("unmount MULTI")
  },
  // returns number of columns for category cards (based on screensize)
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return this.fixedNumberOfCards || 2 // use static card number if configured, otherwise default number
      }

      if (this.$vuetify.breakpoint.lg) {
        return this.fixedNumberOfCards || 2 // use static card number if configured, otherwise default number
      }

      if (this.$vuetify.breakpoint.md) {
        return this.fixedNumberOfCards || 2 // use static card number if configured, otherwise default number
      }
      return 1
    },
  },
}
</script>
